<form class="mc-spring-board" (ngSubmit)="onSubmit(buildSettingsForm)" [formGroup]="buildSettingsForm">
  <div class="mc-spring-board-form-body">
    <mat-form-field mcColor="secondary" class="mc-form-field" hintLabel="Max 250 characters">
      <mat-label>Description</mat-label>
      <textarea matInput #descriptionInput formControlName="Description" placeholder="Description" maxLength="250"></textarea>
      <mat-hint align="end">{{ descriptionInput.value.length }}/250</mat-hint>
      <mat-error>
        <mc-form-control-error-message [form]="buildSettingsForm" controlName="description" type="mc_build_description"></mc-form-control-error-message>
      </mat-error>
    </mat-form-field>

    <div class="mc-form-spacer"></div>

    <div class="mc-form-field">
      <mat-checkbox formControlName="Keep" color="accent-vivid">
        Keep Build
      </mat-checkbox>
    </div>
    <p class="mc-form-note">
      You can mark successful builds as "Keep." You might do this to avoid accidentally deleting it, perhaps with the intention of rolling back to it at some point (i.e., setting the site associated with that build to "Live").
    </p>
    <p *ngIf="build?.LinkedToLiveSite" class="mc-form-note">
      You cannot change a build's "Keep" state while it is linked to a "Live" site.
    </p>

    <ng-container *ngIf="!build.SupportsCaseInsensitivePaths">
      <p class="mc-form-title">Case-Insensitive Paths</p>
      <p class="mc-form-note">
        <mat-icon fontSet="project-titan" fontIcon="icon-alert" class="mc-centered-text-icon"></mat-icon>
        <span>This build does not support case-insensitive paths. To add support, please create a new build.</span>
      </p>
    </ng-container>
  </div>

  <div class="mc-spring-board-form-footer">
    <mc-errors-expansion-panel *ngIf="savingState.generalError$ | async as generalError" compact [generalError]="generalError" [detailedErrors]="savingState.detailedErrors$ | async"></mc-errors-expansion-panel>

    <div class="mc-form-buttons">
      <button type="button" mat-stroked-button (click)="onCancelClicked()">Cancel</button>
      <button type="submit" mat-raised-button color="primary" [disabled]="buildSettingsForm.pristine || buildSettingsForm.invalid || (savingState.loading$ | async)">Save</button>
    </div>
  </div>

  <mc-loader *ngIf="savingState.loading$ | async" class="mc-loader-semi-transparent"></mc-loader>
</form>